import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import { Icons } from '@/icons/icons'
import useUserTool from '@/components/Navigation/AppBarToolbarItems/contextMenus/composables/useUserTool'
import { useI18n } from 'vue-i18n-composable'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'HubContextMenuComponent',
  setup(__props) {

const { t } = useI18n()
const text = {
  ecosystem: t('navigation.hub.ecosystem')
}

// DATA
const iconProduct = ref(Icons.PRODUCTS)

// COMPOSABLES
const { loadTools, toolList } = useUserTool()

// METHODS
function redirect(url: string) {
  window.open(url, '_blank')
}

onMounted(() => loadTools())

return { __sfc: true,t, text, iconProduct, loadTools, toolList, redirect }
}

})